<script lang="tsx" setup>
import { watch, ref, unref, onMounted } from 'vue';
import { storeToRefs } from "pinia";
import { useFVStore } from '../../stores/formvibes';
import ExpandedData from './expanded-data.vue';
import AddNote from './notes/add.vue';
import Status from './status/status.vue';
import { CircleCheck, CloseBold, Loading } from '@element-plus/icons-vue';

const store= useFVStore();
const isExpanded = ref(false);

const {tableData, tableColumns, generalStates, isEditEnable, submissionCount, data, notes, isLoading, isPro, isSaving, pageSizes } = storeToRefs(store);
const status = ref(window.fvGlobalVar.entry_status);
const selectedRow = ref('');
const {
        user_capability: userCapability,
		settings_saved: settingsSaved,
		entry_table_fields: entryTableFields,
	} = window.fvGlobalVar;

const rowIdClicked = ref('');
const colNameClicked = ref('');
const colNamePrevValue = ref('');
const nonEditablColumns = ['id','url','captured','IP', 'user_agent', 'selection'];

onMounted(() => {
    document.addEventListener('keydown', (e) => {
          if(e.key === 'Escape'){
            closeExpand();
          }
     });
});

const handleSizeChange = (val) => {
    generalStates.value.queryParams.per_page = val;
    store.fetchData();
}

const handleCurrentChange = (val) => {
    generalStates.value.queryParams.page_num = val;
    store.fetchData();
}

const handleSelectionChange = (selected) => { 
    generalStates.value.selectedRowsId = selected.map( (item) =>  item.id);     
}

const onClick = async (e,colKey, row) => {
      
    await store.upldateColumnData(row, colKey, colNamePrevValue.value);
    rowIdClicked.value = "";
    colNameClicked.value = "";
}

const rowClick = (row, column, event) => {
    if(isEditEnable.value){
        return;
    }
    
    selectedRow.value = row;
    // isExpanded.value = true;
}

const cellMouseEnters = (row, column, cell, event) => {
    if(isEditEnable.value && !nonEditablColumns.includes(column.property)){
        rowIdClicked.value = row.id;
        colNameClicked.value = column.property;
    }
}

const cellClick = (row, column, cell, event) => {
    if(isEditEnable.value && !nonEditablColumns.includes(column.property)){
        rowIdClicked.value = row.id;
        colNameClicked.value = column.property;
    }
}

watch(selectedRow,()=> {
    if(selectedRow.value){
        isExpanded.value = true;
    }
    else{
        isExpanded.value = false;
    }
})

const closeExpand = () => {
    selectedRow.value = '';
    isExpanded.value = false;
}

watch([data],()=> {
    if(!data.value){
        return;
    }
    const rtData = data.value?.data;
    if(rtData.length > 0){
        rtData.forEach((d) => {
            const { id } = d;
            
            if (id in notes.value) {
                notes.value = {...notes.value};
            }
            else{
                notes.value ={
                    ...notes.value,
                    [id]: 'fv-notes' in d ? JSON.parse(d['fv-notes'])?.reverse() || [] : [],
                }
            }
            
        });
    }
});

</script>
<template>
    <div class="fv-content-wrapper fv-datatable-wrapper">
    <el-table :data="tableData"
        @selection-change="handleSelectionChange"
        @row-click="rowClick"
        @cell-mouse-enter="cellMouseEnters"
        @cell-click="cellClick"
        table-layout="auto"
        width="100%"
        v-loading="isLoading"
        highlight-current-row
    >
        <el-table-column type="selection" width="35" fixed />
        <el-table-column width="60" style="z-index: 2;" fixed v-if="isPro && userCapability?.add_fv_notes && settingsSaved?.enable_notes" >
            <template #default="scope">
                <!-- <el-button style="margin-right: 16px">Add Note</el-button> -->
                <AddNote :row="scope.row" :selectedRow="selectedRow" :closeDialog="closeExpand" />
            </template>
        </el-table-column>
        <el-table-column width="130" v-if="isPro && userCapability?.view_fv_status && settingsSaved?.enable_status">
            <template #default="scope">
                <Status :row="scope.row" :status="status" />
            </template>
        </el-table-column>
        
        <el-table-column
            v-for="col in tableColumns"
            :key="col.key"
            :label="col.title"
            :prop="col.key"
            :width="col.key === 'id' ? '60' : '300'"
            style="white-space: nowrap;"
        >

            <template #default="scope">
                <span v-if="!isEditEnable || nonEditablColumns.includes(col.key)" style="white-space: nowrap;" :class="isEditEnable ? 'edit-active1' : ''">
                    {{ scope.row[col.key] }}
                </span>
                <span v-else-if="isEditEnable && scope.row.id === rowIdClicked && col.key === colNameClicked" style="white-space: nowrap;" :class="isEditEnable ? 'edit-active' : ''" @click="colNamePrevValue = scope.row[col.key]">
                    <ElInput v-model="scope.row[col.key]">
                        <template #suffix>
                            <el-icon @click.stop="onClick($event, col.key, scope.row)">
                                <Loading v-if="isSaving" />
                                <CircleCheck v-else />
                            </el-icon>
                        </template>
                    </ElInput>
                </span>
            </template>
        </el-table-column>
    </el-table>
    <div class="fv-table-pagination" v-if="tableData.length">
        <el-pagination
            class="fv-pagination"
            layout="total, sizes, prev, pager, next" 
            :total="submissionCount"
            :current-page="generalStates.queryParams.page_num"
            :page-sizes="pageSizes" 
            :page-size="generalStates.queryParams.per_page"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
        />
    </div>
    <ExpandedData :row="selectedRow" :closeExpand="closeExpand" v-if="isExpanded" />
    </div>
    
</template>
